import options from './alerts-actions-nav.component';

export default {
    selector: 'dtAlertsActionsNav',
    options
};



// WEBPACK FOOTER //
// ./app/components/alerts-actions/alerts-actions-nav/index.js